module.exports = __webpack_public_path__ + "img/tianmuhu.b2cb2371.jpg";